import { useSyncExternalStore } from "react";

export type Theme = "system" | "light" | "dark";
const storageKey = "pf-theme";
const changeEvent = "pf-theme-change";
const normalize = (value: string | null | undefined): Theme =>
  value === "light" || value === "dark" ? value : "system";

function subscribe(listener: () => void) {
  const syncStorage = (event: StorageEvent) => {
    if (event.key !== storageKey && event.key !== null) return;
    document.documentElement.dataset.theme = normalize(event.newValue);
    listener();
  };
  window.addEventListener("storage", syncStorage);
  window.addEventListener(changeEvent, listener);
  return () => {
    window.removeEventListener("storage", syncStorage);
    window.removeEventListener(changeEvent, listener);
  };
}

export function setTheme(theme: Theme) {
  document.documentElement.dataset.theme = theme;
  try {
    localStorage.setItem(storageKey, theme);
  } catch {
    // The current page still follows the choice when storage is unavailable.
  }
  window.dispatchEvent(new Event(changeEvent));
}

export function useTheme() {
  return useSyncExternalStore(
    subscribe,
    () => normalize(document.documentElement.dataset.theme),
    () => "system" as const,
  );
}
